<template>
  <delete-confirmation-modal ref="delete" @confirm="exclude" @cancel="cancel" :title="title" :text="text" :confirmMessage="confirmMessage"/>
</template>

<script>
export default {
  name: "ModalDelete",
  props: ["text", "show", "values", "title", "confirmMessage"],
  data() {
    return {};
  },
  watch: {
    show: function (value) {
      if (value) this.$refs.delete.open();
      else this.$refs.delete.close();
    },
  },
  methods: {
    cancel() {
      this.$emit("cancel", this.values);
    },
    exclude() {
      this.$emit("exclude", this.values);
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/dashboard/components/ModalDelete.vue